/** @format */

import React, {useContext} from 'react';
import moment from 'moment-business-days';

import {formatShortDate} from './functions/format';

import {QuoteContext} from 'frontier-quoter';

export function DesignDeliveryEstimator() {
    const {order} = useContext(QuoteContext);

    // The server sends a UTC timestamp for ship_due_date, where the date seems to be the
    // last second of the ship day in Eastern time, e.g. Apr 15 03:59:59. So we offset the
    // UTC date back into EST.
    const deliveryDate = order.ship_due_formatted ? moment(order.ship_due_formatted) : null;

    return (
        <div>
            <div>
                <div className="hstack font-label-sm">
                    <span>Arrives</span>
                    <span className="flex-grow-1 border-bottom border-dark mx-2 mt-1"></span>
                </div>
                <div className="hstack justify-content-between font-body-xl">
                    <span>{formatShortDate(deliveryDate)}</span>
                </div>
            </div>
        </div>
    );
}
